import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SharedService } from '../../shared.service';
import { WebhookDefData } from '../../models/sharedModel';
import { errorMsgs, RegExPatterns } from 'src/app/constants';
import { NgForm } from '@angular/forms';
import { takeWhile } from 'rxjs';
import { WebhookCusotmFieldsAllowed, WebHookFormElem, WebHookFormElemFields } from '../../sharedModel';
import { SharedDataService } from '../../shared-data.service';

@Component({
  selector: 'app-web-hook-form',
  templateUrl: './web-hook-form.component.html',
  styleUrls: ['./web-hook-form.component.scss']
})
export class WebHookFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() fromComponent: string;

  @Input() sectionName: string;

  @Input() webHookFormElemCustom: WebHookFormElem;

  @Input() isFormFieldsMandatory: boolean;

  @Input() webhookDefData: WebhookDefData | undefined;

  @Output() webHookFormChange = new EventEmitter();

  @ViewChild('webHookForm', { static: true }) public webHookForm: NgForm;

  regExPatterns = RegExPatterns;

  webHookFormSubscriber: any;

  errorMsgs = errorMsgs;

  idString = '';

  destroySubscription = false;

  customeFieldsError: boolean = false;

  webHookFormElemCustomFields?: WebHookFormElemFields;

  columClass?: string;


  constructor(private sharedService: SharedService, private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'whform');
    this.webHookFormSubscriber = this.webHookForm.form.valueChanges.subscribe(x => {
      const tempObj = {
        formData: this.webHookForm
      }
      this.webHookFormChange.emit(tempObj);
    });

    this.operateFields();
  }

  operateFields() {
    if (this.webHookFormElemCustom) {
      this.webHookFormElemCustomFields = this.webHookFormElemCustom.fields;
      this.columClass = this.webHookFormElemCustom.columClass;
    } else {
      const tempWebHookFormElem: WebHookFormElem = JSON.parse(JSON.stringify(this.sharedDataService.webHookFormElem));
      this.webHookFormElemCustomFields = tempWebHookFormElem.fields;
      this.columClass = tempWebHookFormElem.columClass;
    }
  }


  onCustomFieldsKeyUp(event: Event) {
    let newValue = (event.target as HTMLTextAreaElement).value;

    if (newValue) {
      // if (this.webhookDefData !== undefined) {
      //   this.webhookDefData.custom_fields = newValue;
      // }

      try {
        //  this.hasPasted = false;
        const parsedJson = JSON.parse(newValue);
        if (this.webhookDefData !== undefined) {
          this.webhookDefData.custom_fields = JSON.stringify(parsedJson, null, 2);
        }
        this.customeFieldsError = false;
      } catch (error) {
        // console.log('error', error);
        this.customeFieldsError = true;
        (event.target as HTMLTextAreaElement).value = '';
        if (this.webhookDefData !== undefined) {
          this.webhookDefData.custom_fields = '';
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('abcd',changes);
    // if (changes['webhookDefData']) {
    //   if (this.webhookDefData && this.webhookDefData.custom_fields && typeof this.webhookDefData.custom_fields !== 'string') {
    //     this.webhookDefData.custom_fields = JSON.stringify(this.webhookDefData.custom_fields);
    //     // console.log(this.webhookDefData.custom_fields);
    //   }
    // }
  }

  ngOnDestroy(): void {
    if (this.webHookFormSubscriber) {
      this.webHookFormSubscriber.unsubscribe();
    }
    this.destroySubscription = true;
  }

}
